import React from 'react';
import './Comment.scss';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationCircle} from "@fortawesome/free-solid-svg-icons";

const Comment = props => (
  <div className="CommentContainer">
    <div className="Comment">
      <FontAwesomeIcon icon={faExclamationCircle} />
      <p className="CommentText">{props.content}</p>
    </div>
  </div>
);

export default Comment;
